import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { PasswordSchema } from '../../../../../../schemas/Campaign/PasswordSchema'
import axiosService from '../../../../../../utils/AxiosService'
import Input from '../../../../../FormComponents/Input'
import { toastSuccess, toastError } from '../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function PasswordPart() {
  const { campaign } = useContext(CampaignContext)
  const readOnly = useReadOnly()
  const { id } = useParams()

  const editPassword = ({ password }) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/password`, { campaign: { password } })
    .then(updatedCampaign => {
      campaign.sharing_token = updatedCampaign.sharing_token
      campaign.password = updatedCampaign.password
      toastSuccess(campaign.password ? 'Sharing Link Updated' : 'Sharing Link Created')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div className="border-1 dark:border-rb-dark-mode-lighter rounded-md px-4 pt-4">
      <p className="text-sm font-bold dark:text-white">Password</p>
      <Formik
        key={campaign.password}
        validationSchema={PasswordSchema}
        initialValues={{ password: campaign.password }}
        onSubmit={editPassword}
      >
        {({ handleBlur, handleChange, values, errors, touched }) => (
          <Form>
            <div className="form-item-container w-full grid grid-cols-12">
              <div className="col-span-9">
                <Input error={touched.password && errors.password} placeholder="Password" name='password' onChange={handleChange} onBlur={handleBlur} value={values.password} disabled={readOnly} />
              </div>
              {!readOnly && (
                <button
                  type="submit"
                  className="ml-4 col-span-3 bg-rb-green text-white px-2 rounded-md h-11 mt-6 dark:text-rb-dark-mode"
                >
                  Save
                </button>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})